<template>
    <div class="content">
        <h2 class="title">您的建议是？</h2>
        <p  class="text">我们很期待为您带来最好的服务，请写下来您的建议。</p>
        <el-form ref="form" :model="form" :rules="rules" label-width="80px" label-position="left" style="width: 50%;padding-top: 40px;">
            <el-form-item label="姓名" prop="realName">
                <el-input v-model="form.realName"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="driverPhone">
                <el-input v-model="form.driverPhone"></el-input>
            </el-form-item>
            <el-form-item label="问题描述" prop="msg">
                <el-input type="textarea" v-model="form.msg"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit" :loading="submitLoading">提交咨询</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { postAddFeedback } from '@/api/api'

export default {
    name: 'veniceModal',
    data () {
        return {
            submitLoading: false,
            form: {
                checked: false,
                consultant: 0,
                driverPhone: null,
                isAnonymous: 0,
                isTourists: 1,
                msg: null,
                msgType: '1',
                phoneModel: '浏览器',
                realName: null
            },
            rules: {
                realName: [
                    { required: true, message: '请输入您的姓名', trigger: 'blur' },
                    { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
                ],
                driverPhone: [
                    { required: true, message: '请输入您的手机号', trigger: 'blur' }
                ],
                msg: [
                    { required: true, message: '请输入您遇到的问题', trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        onSubmit () {
            this.submitLoading = true
            this.$refs.form.validate((valid) => {
                if (valid) {
                    postAddFeedback(this.form).then(res => {
                        if (res.data.success) {
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            })
                            this.$refs.form.resetFields()
                        } else {
                            this.submitLoading = false
                            this.$message({
                                message: '提交失败，请刷新后重试！',
                                type: 'warning'
                            })
                        }
                    }).finally(() => {
                        this.submitLoading = false
                    })
                } else {
                    this.submitLoading = false
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .content{
        padding-top: 10px;
        padding-left: 20px;
        background: #ffffff;
        .title{
            text-align: left;
        }
        .text{
            text-align: left;
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/consult/modules/veniceModal.vue